import { PaginatedPlatformMessageListItemsDTO, useGetPlattformMessages } from "@bvhi/backend-api";
import { Card, CardContent, GridPaginationModel, GridSortModel } from "@bvhi/ui-base";
import { keepPreviousData } from "@tanstack/react-query";
import { forwardRef } from "react";

import { toNarrowedTypeOrNull } from "../../../../../utils/ts";
import { BVHIDataGrid } from "../../../../../components/datagrid/bvhi-datagrid";
import { useMessagesSortParams } from "../hooks/use-messages-sort-params";
import { useMessagesDataGridDefinitions } from "../hooks/use-messages-data-grid-definitions";
import { Route } from "../../../../../routes/_main/app/messages.index";

interface Props {
  updateCallback: (paginationModel: GridPaginationModel, sortModel: GridSortModel) => void;
}

export const MessagesDataGrid = forwardRef<HTMLDivElement, Props>(({ updateCallback }, ref) => {
  const searchParams = Route.useSearch();
  const { getSortModelForBackendString } = useMessagesSortParams();
  const { columns } = useMessagesDataGridDefinitions();

  const { data, isFetching } = useGetPlattformMessages(searchParams, {
    query: { throwOnError: (error) => error.status === 500 || error.status === 403, placeholderData: keepPreviousData },
  });

  const messages = toNarrowedTypeOrNull<PaginatedPlatformMessageListItemsDTO>(data?.data, "numberOfItems");

  return (
    <div ref={ref}>
      <Card sx={{ minHeight: 300 }}>
        <CardContent restrictContentWidth={false}>
          <BVHIDataGrid
            columns={columns}
            initialSortModel={getSortModelForBackendString(searchParams.sort && searchParams.sort.length >= 1 ? searchParams.sort[0] : "")}
            loading={isFetching}
            rowCount={messages?.numberOfItems ?? -1}
            rows={messages?.payload ?? []}
            totalPages={messages?.numberOfPages ?? 0}
            updateCallback={updateCallback}
            initalPaginationModel={{
              page: searchParams.page ? searchParams.page : 0,
              pageSize: searchParams.size ? searchParams.size : 25,
            }}
          />
        </CardContent>
      </Card>
    </div>
  );
});
MessagesDataGrid.displayName = "MessagesDataGrid";
